import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { toast } from 'ngx-sonner';

import { ToastrModel } from './toastr.model';

@Component({
  selector: 'app-toastr-success',
  imports: [HlmIconImports, HlmButtonImports],
  providers: [provideIcons({ lucideCircleCheck, lucideX })],
  templateUrl: './toastr.component.html',
})
export class ToastrSuccessComponent implements ToastrModel {
  readonly titre = input<string>('Succès');
  readonly message = input.required<string>();
  readonly icone = 'lucideCircleCheck';
  readonly bgClass = 'bg-feedback-positive-lightest';
  readonly iconClass = 'text-feedback-positive-main';

  readonly id = input.required<string>();

  closeToastr = () => toast.dismiss(this.id());
}
